import { CREATE, DELETE, EDIT } from '@/constants/api'

export const CHURCHES = 'churches'
export const CHURCH = 'church'

export const ENDPOINTS = {
  CREATE_CHURCH: `/${CHURCHES}/${CREATE}`,
  GET_CHURCHES: `/${CHURCHES}/`,
  GET_CHURCH: `/${CHURCHES}/${CHURCH}`,
  UPDATE_CHURCH: `/${CHURCHES}/${EDIT}`,
  DELETE_CHURCH: `/${CHURCHES}/${DELETE}`,
}
